import { Component, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })

export class CryptoService {

  encryptSecretKey: string = "@dga.D@GA@.gov.$a@2023";

  constructor() {
  }

  encryptUsingAES256(text: string): string {
    let encJson = CryptoJS.AES.encrypt(JSON.stringify(text), this.encryptSecretKey).toString();
    let encData = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encJson));
    return encData
  }
  decryptUsingAES256(text: string): string {

    let decData = CryptoJS.enc.Base64.parse(text).toString(CryptoJS.enc.Utf8);
    let bytes = CryptoJS.AES.decrypt(decData, this.encryptSecretKey).toString(CryptoJS.enc.Utf8);
    return JSON.parse(bytes)
  }
}











